// const GIF = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAA'
var GIF = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACAD';
var PNG = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR4';
var index = {
  GIF: GIF,
  PNG: PNG
};

export { index as default };
